import moment from "moment";

export function monthYear(timestamp) {
  if (!timestamp) return null;
  return timestamp && moment(timestamp).format("MM/YY");
}

export function monthFullYear(timestamp) {
  return timestamp && moment(timestamp).format("MM/YYYY");
}

export function monthFullYearHyphen(timestamp) {
  return timestamp && moment(timestamp).format("MM-YYYY");
}

export function dateFormFormat(timestamp) {
  return timestamp && moment(timestamp).format("YYYY-MM-DD");
}

export function shortDate(timestamp) {
  return timestamp && moment(timestamp).format("MM/DD/YYYY");
}

export function shortDateYY(timestamp) {
  return timestamp && moment(timestamp).format("MM/DD/YY");
}

export function shortDateYYandTime(timestamp) {
  if (!timestamp) return "";
  return timestamp && moment(timestamp).format("MM/DD/YY h:mm A");
}

export function timeStamp(timestamp) {
  return timestamp && moment(timestamp).format("h:mm A");
}

export function shortDateAndTimestamp(timestamp) {
  return timestamp && moment(timestamp).format("MM/DD/YYYY h:mm A");
}

export function alphaMonthYear(timestamp) {
  return timestamp && moment(timestamp).format("MMMM YYYY");
}



// WEBPACK FOOTER //
// ./app/lib/formatters/date.js